export default __webpack_public_path__ + "images/5755e6a0170da3714612aa037d3c09c1-form-row--toggle.gif";